//GET ALL FAQ
export const GET_ALL_FAQ_REQ = "GET_ALL_FAQ_REQ";
export const GET_ALL_FAQ_ERR = "GET_ALL_FAQ_ERR";
export const GET_ALL_FAQ_SUCC = "GET_ALL_FAQ_SUCC";
